import { Decimal } from 'decimal.js';
import type { AccountDTO as Account } from '@hotjar/account';
import { subscriptionAPI } from './subscription';

const getLanguage = (nav: Navigator): string => {
  if (nav.languages) {
    return nav.languages[0];
  }

  return nav.language;
};
const language = getLanguage(window.navigator);

export const prettifyPriceWithCurrencySymbol =
  (currencySymbol: string | undefined = '', minimumFractionDigits = 2, maximumFractionDigits = 2) =>
  (price: number | string | Decimal, decimaPlaces = 2): string => {
    const decimalPrice = new Decimal(price);
    const localeNumber = decimalPrice
      .toDP(decimaPlaces, Decimal.ROUND_DOWN)
      .toNumber()
      .toLocaleString(language, { minimumFractionDigits, maximumFractionDigits });

    return `${currencySymbol}${localeNumber}`;
  };

/**
 * Get preview of cost for a new site with a particular plan
 */
export function getNewSiteCosts(
  account: Account,
  planIdentifier: string,
): Promise<{ totalRecurringCost: string; newSiteRecurringCost: string }> {
  const costSpecs = [
    {
      always_on_rate: 0,
      plan_id: planIdentifier,
    },
  ];
  return subscriptionAPI.preview(account, costSpecs, undefined, undefined).then((priceSummary) => {
    const totalRecurringCost = priceSummary.future.total.toString();
    const proRataCost = priceSummary.charge?.total.toString() ?? '0';
    const newSite = priceSummary.future.lineItems.find(
      (lineItem) => lineItem.sitePlanInfo.siteReference.siteId === null,
    );
    const newSiteRecurringCost = newSite ? newSite.total.toString() : '0';
    return { totalRecurringCost, newSiteRecurringCost, proRataCost };
  });
}
